
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactInfoCard from '../components/ContactInfoCard';
import ContactForm from '../components/ContactForm';
import ContactMap from '../components/ContactMap';
import { MapPin, Phone, Mail, Clock, Globe } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '../components/ui/use-toast';

const Kontakt = () => {
  const [searchParams] = useSearchParams();
  const { toast } = useToast();

  // Check for success parameter in URL (from FormSubmit redirect)
  useEffect(() => {
    if (searchParams.get('success') === 'true') {
      toast({
        title: "Nachricht gesendet!",
        description: "Vielen Dank für Ihre Anfrage. Wir melden uns schnellstmöglich bei Ihnen.",
        duration: 5000,
      });
      // Clear the URL parameter
      window.history.replaceState({}, '', '/kontakt');
    }
  }, [searchParams, toast]);

  const contactInfo = [
    {
      icon: MapPin,
      title: "Adresse",
      content: "Max-Planck-Straße 4\n85609 Aschheim"
    },
    {
      icon: Phone,
      title: "Telefon",
      content: "+49 157 7030 5796",
      link: "tel:+4915770305796"
    },
    {
      icon: Mail,
      title: "E-Mail",
      content: "am@amming.de",
      link: "mailto:am@amming.de"
    },
    {
      icon: Globe,
      title: "Website",
      content: "www.amming.de",
      link: "https://www.amming.de"
    },
    {
      icon: Clock,
      title: "Öffnungszeiten",
      content: "Montag - Freitag: 08:00 - 18:00\nSamstag: 09:00 - 14:00\nSonntag: Geschlossen"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="section-padding bg-primary-brand text-white pt-32">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Kontakt</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed opacity-90">
            Nehmen Sie Kontakt mit uns auf. Wir sind Ihr zuverlässiger Partner im Bauwesen und freuen uns auf Ihre Anfrage.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20">
            
            {/* Contact Information Cards */}
            <div className="space-y-6">
              <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-primary-brand">
                  Kontaktieren Sie uns
                </h2>
              </div>

              {/* Contact Info Cards */}
              <div className="grid grid-cols-1 gap-6">
                {contactInfo.map((info, index) => (
                  <ContactInfoCard
                    key={index}
                    icon={info.icon}
                    title={info.title}
                    content={info.content}
                    link={info.link}
                    index={index}
                  />
                ))}
              </div>
            </div>

            {/* Contact Form */}
            <ContactForm />
          </div>
        </div>
      </section>

      {/* Map Section */}
      <ContactMap />

      <Footer />
    </div>
  );
};

export default Kontakt;
